class CurrencyModal extends HTMLElement {
  constructor() {
    super()
    this.modal = this.querySelector('.currency-modal')
    this.modalContentFront = this.querySelector('.front-modal')
    this.modalContentBack = this.querySelector('.back-modal')
    this.closeSpanX = this.querySelector('.currency-modal__close-btn')
    this.closeModalBtn = this.querySelector('.currency-modal-overlay')
    this.locationFormFront = this.querySelector(
      'form[id=modal--localization][modal-side=front]'
    )
    this.locationFormBack = this.querySelector(
      'form[id=modal--localization][modal-side=back]'
    )
    this.previousFocusedElement = null
    this.regionSelect = this.querySelector('#modal--region-region')
    this.load()
    this.updateSelectedLocale()
  }

  load() {
    this.addListeners()
  }

  updateSelectedLocale() {
    const localeSelector = this.querySelector('[name=locale_code]')
    if (localeSelector) {
      localeSelector.value = window.Shopify.locale
    }
  }

  addListeners() {
    this.closeSpanX.addEventListener('click', () => this.closeModal())
    this.closeModalBtn.addEventListener('click', () => this.closeModal())

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.style.display === 'flex') {
        this.closeModal()
      }
    })

    window.onclick = (event) => {
      if (event.target === this.modal) {
        this.closeModal()
      }
    }

    this.regionSelect.addEventListener('sl-change', (event) => {
      const [selectedOption] = event.target.selectedOptions
      if (selectedOption) {
        this.querySelector('.flag-wrapper').innerHTML = selectedOption.querySelector('.flag-wrapper').innerHTML
      }
    })
  }

  showModal() {
    this.setAttribute('aria-expanded', 'true')
    this.previousFocusedElement = document.activeElement
    this.modalContentFront.style.display = 'none'
    this.modal.style.display = 'flex'
    this.modalContentBack.style.display = 'block'
    document.body.classList.add('overflow-hidden')
    this.trapFocus()
  }

  closeModal() {
    this.setAttribute('aria-expanded', 'false')
    this.modal.style.display = 'none'
    document.body.classList.remove('overflow-hidden')
    document.querySelector('.header-language-selector').setAttribute('aria-expanded', 'false')

    if (this.previousFocusedElement) {
      this.previousFocusedElement.focus()
    }
  }

  trapFocus() {
    const focusableElements = this.modal.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )

    if (focusableElements.length > 0) {
      focusableElements[0].focus()
    }

    this.modal.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey && document.activeElement === firstElement) {
          lastElement.focus()
          event.preventDefault()
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          firstElement.focus()
          event.preventDefault()
        }
      }
    })
  }
}

customElements.define('modal-currency-root', CurrencyModal)
